export default __webpack_public_path__ + "static/shopping-centre-4-03e11ae8aa2343352200bde637fc51e4.jpg";